<template>
	<div>
		<div class="modal-body pt-0">
			<div class="row">
				<!-- CHECK TO PRINT BEGIN -->
				<div class="col-md-5 p-0 print section-to-print">
					<div id="posCheck">
						<div id="depName" class="d-flex justify-content-center"><strong>DUTY-FREE - {{ shopName
							}}</strong></div>
						<div id="depAddress" class="d-flex justify-content-center bottom-bordered"><i>{{ shopAddress
							}}</i>
						</div>
						<div class="d-flex justify-content-between"><span>{{ dateTime }}</span> <span
							style="text-align: right;">{{$t('sidebar.pos.check')}}: {{ currentSuspendId ? currentSaleSuspendNumber : currentSaleNumber }}</span>
						</div>
						<!--<div class="d-flex justify-content-between"><span>{{$t('xAtchot.cashier')}}:{{ cashierFullName }}</span> <span
							style="text-align: right;">POS №:{{ cashboxNumber }}</span></div>-->
						<div class="d-flex justify-content-between"
							 :class="returnItemsCount == 0 ? 'bottom-bordered' : ''">
							<!--<span>{{$t('pos.saller')}}:{{ currentSellerName }}</span> --><span
							style="text-align: right;">{{$t('pos.items')}}:{{ totalCount }}</span>
						</div>
						<div
							v-if="returnItemsCount !== 0"
							class="d-flex justify-content-end bottom-bordered">
							<span style="text-align: right;">Возврат кол-во:{{ returnItemsCount }}</span>
						</div>
						<div class="posCheckTable bottom-bordered">
							<table>
								<thead>
								<tr>
									<th class="alignedLeft" style="width: 50%; word-break: break-all;">
										{{$t('pos.product')}}
									</th>
									<th class="alignedCenter" style="width: 17%; word-break: break-all;">
										{{$t('sale.kol-vo')}}
									</th>
									<th class="alignedCenter" style="width: 5%;">{{$t('promo-to-product.promo')}}</th>

									<th class="alignedRight" style="width: 32%; word-break: break-all;">
										{{$t('incomes.create.price')}}
									</th>
								</tr>
								</thead>
								<tbody>
								<tr
									v-for="(item, index) in getCartItems"
									:key="'checkItem' + index"
									:class="item.count < 0 ? 'returnItemBordered' : ''"
								>
									<td class="alignedLeft" style="width: 50%; word-break: break-all;">
										<strong>{{ index + 1 }}.</strong>{{ item.name
										}}/<strong>{{item.artikul}}</strong>/{{item.genderName }}/{{ item.colorName
										}}/<strong>{{ item.size }}</strong>
									</td>
									<td class="alignedCenter" style="width: 17%; word-break: break-all;">
										{{ item.count > 0 ? item.count : -item.count }}
									</td>
									<td class="alignedCenter" style="width: 17%; word-break: break-all;">
										{{ promotionforPrint(item) }}
									</td>

									<td class="alignedRight" style="width: 32%; word-break: break-all;">
										{{ item.discountPriceUzs * item.count | currency({symbol: userDepCurrencyName,
										fractionCount: 2, symbolPosition:
										'back',
										thousandsSeparator: ''})}}
									</td>

								</tr>
								</tbody>
							</table>
						</div>
						<div class="posCheckTotal bottom-bordered">
							<table>
								<tbody>
								<tr>
									<td class="alignedLeft">{{$t('warehouse.table.totalIncomeUzs')}}</td>
									<td class="alignedRight">{{ parseFloat(totalSum) | currency({symbol:
										userDepCurrencyName, fractionCount: 2,
										symbolPosition:
										'back', thousandsSeparator: ''}) }}
									</td>
								</tr>
								<tr>
									<td class="alignedLeft">{{$t('pos.ndc')}}</td>
									<td class="alignedRight">{{ parseFloat(totalSum)/6 | currency({symbol:
										userDepCurrencyName, fractionCount: 2,
										symbolPosition:
										'back', thousandsSeparator: ''}) }}
									</td>
								</tr>
								<tr>
									<td class="alignedLeft">{{$t('xAtchot.pay')}}</td>
									<td class="alignedRight">{{ parseFloat(totalSum) | currency({symbol:
										userDepCurrencyName, fractionCount: 2,
										symbolPosition:
										'back', thousandsSeparator: ''}) }}
									</td>
								</tr>
								<!--<tr>-->
									<!--<td class="alignedLeft">{{$t('sale.payed')}}</td>-->
									<!--<td class="alignedRight">{{ totalPaid | currency({symbol: userDepCurrencyName,-->
										<!--fractionCount: 2, symbolPosition:-->
										<!--'back', thousandsSeparator: ''}) }}-->
									<!--</td>-->
								<!--</tr>-->
								<tr v-if="returnItemsSum !== 0" class="returnItemBordered">
									<td class="alignedLeft">{{$t('pos.return')}}</td>
									<td class="alignedRight">{{ -returnItemsSum | currency({symbol: userDepCurrencyName,
										fractionCount: 2,
										symbolPosition:
										'back', thousandsSeparator: ''}) }}
									</td>
								</tr>
								<tr v-if="parseFloat(sponsorshipAmount) > 0" class="returnItemBordered">
									<td class="alignedLeft">{{$t('sidebar.sales.sponsor')}}</td>
									<td class="alignedRight">{{ sponsorshipAmount | currency({symbol:
										userDepCurrencyName, fractionCount: 2,
										symbolPosition:
										'back', thousandsSeparator: ''}) }}
									</td>
								</tr>
								<tr v-if="parseFloat(debtAmount) > 0">
									<td class="alignedLeft">{{$t('xAtchot.debt')}}</td>
									<td class="alignedRight">{{ debtAmount | currency({
										symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
										thousandsSeparator: ''
										}) }}
									</td>
								</tr>
								<!--<tr>-->
								<!--<td class="alignedLeft">{{$t('promo-to-product.promo')}}</td>-->
								<!--<td class="alignedRight" v-if="customPromotion">-->
								<!--{{ customPromotion.discount }}-->
								<!--<span v-if="customPromotion.promotionType == '%'">{{ customPromotion.promotionType }}</span>-->
								<!--<span v-else>{{ userDepCurrencyName }}</span>-->
								<!--</td>-->
								<!--<td class="alignedRight" v-else>{{ 0 | currency({symbol: '',-->
								<!--symbolPosition: 'back', thousandsSeparator: ''}) }}-->
								<!--</td>-->
								<!--</tr>-->
								</tbody>
							</table>
						</div>
						<div class="posThanks">
							<p><i>-- {{$t('pos.please')}}! --</i></p>
						</div>
					</div>
				</div>
				<!-- CHECK TO PRINT END -->

				<div class="col-md-5 pl-0 hidden-print">
					<payment-method :open-clicked="openClicked"
									:totalSum="totalSum"
									:saleCurrencyName="saleCurrencyName"
									@debtAmountChanged="setDebtAmount"
									@sponsorshipAmountChanged="setSponsorshipAmount"
									ref="paymentMethod"
									:allItems="getCartItems"
					>
					</payment-method>
				</div>
				<div class="col-md-2 p-0 hidden-print">
					<div class="box box-solid bg-orange">
						<div class="box-body p-0">
							<div class="col-md-12" style="padding: 10px; padding-bottom: 0;">
								<strong>
									{{$t('xAtchot.item')}}
								</strong>
								<br>
								<span class="lead text-bold total_quantity">{{ totalCount }}</span>
							</div>

							<div class="col-md-12" style="padding: 10px; padding-top: 0;">
								<hr style="margin: 8px 0;">
								<strong>
									{{$t('xAtchot.pay')}}:
								</strong>
								<br>
								<span class="lead text-bold total_payable_span">{{ totalSum | currency({symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'}) }}</span>
							</div>
							<div class="col-md-12" style="padding: 10px; background: orange;">
								<strong>
									{{$t('promo-to-product.promo')}}:
								</strong>
								<br>
								<span class="lead text-bold total_payable_span" v-if="customPromotion">
									{{ customPromotion.discount }}
									<span v-if="customPromotion.promotionType == '%'">{{ customPromotion.promotionType }}</span>
									<span v-else>{{ userDepCurrencyName }}</span>
								</span>
								<span class="lead text-bold total_payable_span" v-else>{{ 0 | currency({symbol: '',
										symbolPosition: 'back', thousandsSeparator: ' '}) }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer pb-0 hidden-print">
			<button type="button" @click="close" class="btn btn-default" data-dismiss="modal">{{$t('xAtchot.close')}}
			</button>
			<button type="submit"
					@click="success(false)"
					class="btn btn-primary"
					id="pos-save-without-check"
					:disabled="posDisabled"
			>
				{{$t('sale.no-check')}}
			</button>
			<button type="submit"
					@click="success(true)"
					class="btn btn-success"
					id="pos-save"
					:disabled="posDisabled"
			>
				{{$t('sale.check')}}
			</button>
		</div>
	</div>
</template>

<script>
	import PaymentMethod from './blocks/PaymentMethod'
	import {mapActions, mapGetters, mapState} from 'vuex'

	const sleep = (milliseconds) => {
		return new Promise(resolve => setTimeout(resolve, milliseconds))
	}
	export default {
		name: 'MultiplePay',
		props: ['totalCount', 'totalSum', 'openClicked', 'saleCurrencyName'],
		data: () => {
			return {
				dateTime: '',
				isMounted: false,
				debtAmount: 0,
				sponsorshipAmount: 0,
			}
		},
		computed: {
			...mapState('wholesalePos', [
				'shopName', 'currentSaleNumber',
				'shopAddress', 'cashierFullName', 'currentSellerName',
				'currentSaleSuspendNumber', 'currentSuspendId', 'customPromotion',
				'posDisabled'
			]),
			...mapState('references', [
				'allPaymentMethods'
			]),
			...mapGetters('wholesalePos', [
				'getCartItems'
			]),
			...mapState('certificates', [
				'certificateForPos'
			]),
			...mapState([
				'cashboxNumber', 'userDepCurrencyName'
			]),
			totalPaid() {
				if (this.isMounted) {
					return this.$refs.paymentMethod.totalPaid;
				}
			},
			returnItemsSum() {
				let sum = 0;
				this.getCartItems.forEach(el => {
					if (el.count < 0) {
						sum += el.count * el.discountPriceUzs;
					}
				});
				return sum;
			},
			returnItemsCount() {
				let count = 0;
				this.getCartItems.forEach(el => {
					if (el.count < 0) {
						count -= el.count;
					}
				});
				return count;
			},
		},
		methods: {
			promotionforPrint(item) {
				let promoparam;
				if (item.promotions) {
					for (let i = 0; i < item.promotions.length; i++) {
						if (item.promotions[i].type == "%" && item.promotions[i].value > 0) {
							promoparam = item.promotions[i].value + '%'
						}
						if (item.promotions[i].type == "PUL" && item.promotions[i].value > 0) {
							promoparam = item.promotions[i].value
						}

					}
					return promoparam;
				}

			},
			...mapActions('references', [
				'loadPaymentMethods'
			]),
			close() {
				this.$emit('close')
			},
			setDebtAmount(debtAmount) {
				this.debtAmount = debtAmount;
			},
			setSponsorshipAmount(sponsorshipAmount) {
				this.sponsorshipAmount = sponsorshipAmount;
			},
			makeCurrentDateTime() {
				let now = new Date();
				let year = now.getFullYear();
				let month = now.getMonth() + 1;
				let day = now.getDate();
				let hour = now.getHours();
				let minute = now.getMinutes();
				let second = now.getSeconds();
				if (month.toString().length == 1) {
					month = '0' + month;
				}
				if (day.toString().length == 1) {
					day = '0' + day;
				}
				if (hour.toString().length == 1) {
					hour = '0' + hour;
				}
				if (minute.toString().length == 1) {
					minute = '0' + minute;
				}
				if (second.toString().length == 1) {
					second = '0' + second;
				}
				this.dateTime = year + '/' + month + '/' + day + ' ' + hour + ':' + minute + ':' + second;
			},
			async success(isCheck) {
				this.$store.commit('wholesalePos/setPosDisabled', true);
				let paymentFinal = [];
				this.$refs.paymentMethod.payments.forEach(payment => {
					let obj = {
						paymentTypeId: payment.paymentMethod ? payment.paymentMethod.id : null,
						paymentTypeCode: payment.paymentMethod ? payment.paymentMethod.code : null,
						value: payment.amount,
						comment: this.$refs.paymentMethod.paymentComment
					}
					if (payment.certificate) {
						obj.certificate = payment.certificate;
						obj.certificateId = this.certificateForPos ? this.certificateForPos.id : null;
					}
					if (obj.paymentTypeId && obj.value.toString().trim() !== '') {
						if (obj.value < 0) {
							if (this.totalPaid >= parseFloat(this.totalSum) - this.$refs.paymentMethod.payments.find(el => el.paymentMethod.code == 'QARZGA').amount
								- this.$refs.paymentMethod.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount) {
								paymentFinal.push(obj)
							}
						} else if (obj.value == 0) {
							if (this.totalSum == 0) {
								paymentFinal.push(obj)
							}
						} else if (obj.value > 0) {
							paymentFinal.push(obj)
						}
					}
				})
				if (paymentFinal.length > 0 &&
					(this.totalPaid >= parseFloat(this.totalSum) - parseFloat(this.$refs.paymentMethod.payments.find(el => el.paymentMethod.code == 'QARZGA').amount)
						- parseFloat(this.$refs.paymentMethod.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount) ||
						parseFloat(this.$refs.paymentMethod.payments.find(el => el.paymentMethod.code == 'QARZGA').amount) == this.totalPaid)) {
					this.$emit('success',
						isCheck,
						paymentFinal,
						this.totalPaid,
						this.$refs.paymentMethod.payments.find(el => el.paymentMethod.code == 'QARZGA').amount,
						this.returnItemsCount,
						this.returnItemsSum,
						this.sponsorshipAmount
					);
				} else {
					this.$vs.notify({
						title: 'Пожалуйста, заполните правильно',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
					this.$store.commit('wholesalePos/setPosDisabled', false);
				}
			},
		},
		/** --WATCHERS-- **/
		watch: {
			openClicked: {
				handler(newVal) {
					if (newVal) {
						this.$options.interval = setInterval(this.makeCurrentDateTime, 1000);
					} else {
						clearInterval(this.$options.interval);
					}
				}
			}
		},
		/** --MOUNTED HOOK-- **/
		mounted() {
			this.makeCurrentDateTime();
			this.isMounted = true
		},
		/** --CREATED HOOK-- **/
		created() {
		},

		/** --BEFORE DESTROY HOOK-- **/
		beforeDestroy() {
			clearInterval(this.$options.interval);
		},
		components: {
			PaymentMethod,
		}
	}
</script>

<style scoped lang="scss">
	// @import url('https://fonts.googleapis.com/css?family=Inconsolata');

	.alignedLeft {
		text-align: left;
	}

	.alignedRight {
		text-align: right;
	}

	.alignedCenter {
		text-align: center;
	}

	#posCheck {
		border: 1px solid #aaa;
		box-shadow: 1px 2px 5px 2px #aaa;
		padding: 10px;
		height: 27rem;
		font-family: monospace;
		font-size: 13px;
		overflow-y: auto;
		width: 100mm;

		#depName {
			font-size: 18px;
		}

		.bottom-bordered {
			padding-bottom: 2px;
			border-bottom: .5px dashed #444;
		}

		table {
			width: 100%;
		}

		.returnItemBordered {
			border: .5px dotted black;
		}

		td, th {
			border: none;
		}

		.posCheckTotal {
			table {
				td {
					font-weight: bold;
					font-size: 13px;
				}
			}
		}

		.posThanks {
			p {
				text-align: center;
				font-weight: bold;
				font-size: 13px;
			}
		}
	}

	.box-body {
		border-top-left-radius: 0;
		border-top-right-radius: 0;
		border-bottom-right-radius: 3px;
		border-bottom-left-radius: 3px;
		padding: 10px;
	}

	hr {
		margin-top: 20px;
		margin-bottom: 20px;
		border: 0;
		border-top: 1px solid #eee;
	}

	.bg-orange {
		background-color: #20a8d8 !important;
	}

	/*@media print {
		.hidden-print {
			display: none;
		}

		.card {
			box-shadow: none;
		}
		body * {
			visibility: hidden;
		}
		#section-to-print, #section-to-print * {
			visibility: visible;
		}
		#section-to-print {
			position: absolute;
			left: 0;
			top: 0;
		}
	}*/
</style>
